export enum ComponentSize {
  BIG = 'big',
  MEDIUM = 'medium',
  SMALL = 'small',
}
